import { render, staticRenderFns } from "./tableBudgets.vue?vue&type=template&id=5dfaf83e&scoped=true"
import script from "./tableBudgets.vue?vue&type=script&lang=js"
export * from "./tableBudgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfaf83e",
  null
  
)

export default component.exports